import axios from "../../../privateApi";

export type PossiblePaths = {
  id: number;
  name: string;
}[][];

export const getPossiblePaths: (
  evoPathId: number,
) => Promise<PossiblePaths> = async (evoPathId) => {
  let url = `/evolved-players/${evoPathId}/possible-paths`;
  const res = await axios.get(url);
  return res.data;
};
